import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AutoFocusDirective } from '@shared/utils/directives/auto-focus.directive';
import { ButtonBusyDirective } from '@shared/utils/directives/button-busy.directive';
import { FileDownloadService } from '@shared/utils/services/file-download.service';
import { LocalStorageService } from '@shared/utils/services/local-storage.service';
import { MomentFormatPipe, MomentTimeFormatPipe } from '@shared/utils/pipes/moment-format.pipe';
import { VfBlobService } from '@shared/utils/services/vf-blob-service';
import { DigitOnlyDirective } from '@shared/utils/directives/digit-only.directive';
import { InputTagsComponent } from './components/input-tags/input-tags.component';
import { TaskWatcherComponent  } from './components/taskWatcherComponent/task-watcher.component';
import { TaskContributorComponent } from './components/taskContributorComponent/task-contributor.component';
import { ContributorStackComponent } from './components/contributorStackComponent/contributor-stack.component';
import { AddModule, CloseModule, TagModule } from '@carbon/icons-angular';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule, X, Search, Check, Users, UserPlus, UserMinus, Trash2 } from 'lucide-angular';

@NgModule({
    imports: [
        CommonModule,
        CloseModule,
        AddModule,
        TagModule,
        FormsModule,
        LucideAngularModule.pick({ X, Search, Check, Users, UserPlus, UserMinus, Trash2 })
    ],
    providers: [
        FileDownloadService,
        LocalStorageService,
        VfBlobService
    ],
    declarations: [
        ButtonBusyDirective,
        AutoFocusDirective,
        MomentFormatPipe,
        MomentTimeFormatPipe,
        DigitOnlyDirective,
        InputTagsComponent,
        TaskWatcherComponent,
        TaskContributorComponent,
        ContributorStackComponent
    ],
    exports: [
        ButtonBusyDirective,
        AutoFocusDirective,
        MomentFormatPipe,
        MomentTimeFormatPipe,
        DigitOnlyDirective,
        InputTagsComponent,
        TaskWatcherComponent,
        TaskContributorComponent,
        ContributorStackComponent
    ]
})
export class UtilsModule { }
